import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import { useShop, API } from "../context/ShopContext";
import { useLocale } from "../context/LocaleContext";
import { PageTitle } from "../components/Shared";
import Seo from "../components/Seo";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const imgSrc = (path) => (path && path.startsWith("/api") ? `${BACKEND_URL}${path}` : path);

const content = {
  it: {
    title: "Portfolio",
    seoDesc: "Il portfolio IdeaMedia: oltre 100 siti web, e-commerce, portali, web app e landing page realizzati per aziende in tutta Italia.",
    all: "Tutti i lavori",
    empty: "Nessun lavoro in questa categoria.",
    works: "lavori",
    work: "lavoro",
  },
  en: {
    title: "Portfolio",
    seoDesc: "The IdeaMedia portfolio: over 100 websites, e-commerce stores, portals, web apps and landing pages built for businesses across Italy.",
    all: "All works",
    empty: "No works in this category.",
    works: "works",
    work: "work",
  },
};

const Portfolio = () => {
  const { lang } = useShop();
  const { lp } = useLocale();
  const c = content[lang];
  const [searchParams, setSearchParams] = useSearchParams();
  const activeCat = searchParams.get("cat") || "";
  const [items, setItems] = useState([]);
  const [cats, setCats] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const [itemsRes, catsRes] = await Promise.all([
          axios.get(`${API}/portfolio`),
          axios.get(`${API}/portfolio/categories`),
        ]);
        setItems(itemsRes.data);
        setCats(catsRes.data);
      } catch (e) {
        console.error("Portfolio load failed", e);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  const filtered = activeCat ? items.filter((i) => i.categories.includes(activeCat)) : items;
  const catName = (slug) => {
    const cat = cats.find((x) => x.slug === slug);
    return cat ? cat.name[lang] : slug;
  };

  return (
    <div data-testid="portfolio-page">
      <Seo title={c.title} description={c.seoDesc} />
      <PageTitle title={c.title} />

      <div className="idm-container idm-wide idm-shop-layout">
        <div className="idm-cat-filters idm-pf-filters" data-testid="portfolio-filters">
          <button
            className={!activeCat ? "active" : ""}
            onClick={() => setSearchParams({})}
            data-testid="pf-filter-all"
          >
            {c.all}
          </button>
          {cats.map((cat) => (
            <button
              key={cat.slug}
              className={activeCat === cat.slug ? "active" : ""}
              onClick={() => setSearchParams({ cat: cat.slug })}
              data-testid={`pf-filter-${cat.slug}`}
            >
              {cat.name[lang]}
            </button>
          ))}
        </div>

        {loading ? (
          <div className="idm-loading" data-testid="loading">
            <span className="idm-spinner" />
          </div>
        ) : (
          <>
            <p className="idm-results-count" data-testid="pf-count">
              {filtered.length} {filtered.length === 1 ? c.work : c.works}
            </p>
            {filtered.length === 0 && <p className="idm-text">{c.empty}</p>}
            <div className="idm-pf-grid" data-testid="portfolio-grid">
              {filtered.map((item) => (
                <Link
                  to={lp(`/portfolio/${item.slug}`, item.slug_en)}
                  className="idm-pf-card"
                  key={item.id}
                  data-testid={`pf-item-${item.id}`}
                >
                  <div className="idm-pf-img">
                    {item.image ? (
                      <img src={imgSrc(item.image)} alt={item.title[lang]} loading="lazy" />
                    ) : (
                      <div className="idm-pf-noimg" />
                    )}
                    <div className="idm-pf-overlay">
                      <h3>{item.title[lang]}</h3>
                      <span>{catName(item.category)}</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Portfolio;
